<template>
  <div class="c-app page" :class="{ 'c-dark-theme': darkMode }">
    
    <Sidebar />
    <CWrapper>
        <div class="c-body">
            <main class="c-main p-0 position-relative">
                <transition name="fade">
                    <CElementCover
                        :style="{
                            'z-index':1,
                            'background-color':'#f6f6f6'
                        }"
                        :boundaries="[{ sides: ['top', 'left'], query: '.media-body' }]"
                        :opacity="1"
                        v-show="storePageLoading"
                    >
                        <CSpinner 
                            size="5xl" 
                            color="primary"
                            :style="{
                                width: '3rem',
                                height: '3rem'

                            }"
                        />
                    </CElementCover>
                </transition>
                
                <child />
            </main>
        </div>
    </CWrapper>
  </div>
</template>

<script>
import Sidebar from "£lement/sidebar";
import { mapGetters } from "vuex";
export default {
    name: "BuilderLayout",

    components: {
        Sidebar
    },

    computed: {
        ...mapGetters({
            darkMode: "panel/darkMode",
            check_commercial:"auth/check_commercial",
            storePageLoading: "page/loading",
        })
    },
    mounted(){
        this.$store.dispatch('panel/minimizeSideBar');
    }
};
</script>
<style scoped lang="scss">
    .container-fluid{
        padding: 0;
    }
</style>
